// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__d7dQ8","items":"Menu_items__fFgMP","selected":"Menu_selected__yWkn2","config":"Menu_config__eR17T"};